<template>
  <div class="create-jobs__main">
    <b-skeleton-wrapper>
      <b-card class="create-jobs__helper">
        <span style="font-size: 16px; display: block; color: #575757;">Create Job</span>
        Use this flow to set up your desired job with tasks that will be completed in an ordered fashion. 
        After selecting devices, creating tasks and executing - the tasks will be executed on each device in that subset.
      </b-card>
      <b-skeleton style="margin-bottom: 0; transition: all 2000ms;" 
        :style="computedStepper === '100%' ? 'background-color: rgb(50 200 72 / 44%)' : 'background-color: rgb(50 181 200 / 44%)'" 
        :width="computedStepper"></b-skeleton>
      <b-tabs content-class="mt-3" v-model="jobFormIndex">
        <!-- JOB TAB -->
        <b-tab :title-link-class="'dm__tab-link'" title="Tasks" @click="jobFormIndex = 0;">
          <div class="create-jobs__tab-pane">
            <b-card class="create-jobs__tab-pane--available-selected">
              <div>
                <small>Available</small>
                <div class="create-jobs__tab-pane--list">
                  <div class="create-jobs__tab-pane--list-item" style="align-items: center;" v-for="task in computedAvailableTaskList" :key="task.type + '-AVAILABLE'">
                    <b-button @click="addTask(task)" class="create-jobs__row-button">+</b-button>
                    <small class="create-jobs__tab-pane--list-item-text">
                      {{ task.type }} 
                    </small>
                  </div>
                </div>
              </div>
              <div>
                <small>Selected</small>
                <div class="create-jobs__tab-pane--list">
                  <div class="create-jobs__tab-pane--list-item" v-for="(task, index) in computedSelectedTaskList" :key="task.type + index + '-SELECTED'">
                    <small>
                      {{ task.type }} 
                      <div v-for="(requirement, tIndex) in task.payloadTemplate" :key="`task-requirements-${index}-${tIndex}`">
                        <multiselect 
                          open-direction="bottom"
                          :hideSelected='true' 
                          :label="'label'"
                          :options="
                            bedManagerService[requirement.source] && 
                            bedManagerService[requirement.source].data ? 
                              packageListMutation(bedManagerService[requirement.source].data).map((item) => {
                                return { ...item, label: `${item.label} (${item.packageType} ${item.version})`}
                              }) : []" 
                            v-model="task.payload[requirement.id]"
                          :placeholder="`Select ${requirement.source}`" />
                      </div>
                    </small>
                    <b-button @click="removeTask(index)" class="create-jobs__row-button">-</b-button>
                  </div>
                </div>
              </div>
              <div class="create-jobs__tab-pane--available-selected-divider"></div>
            </b-card>
          </div>
        </b-tab>

        <!-- DEVICES TAB -->
        <b-tab :title-link-class="'dm__tab-link'" title="Devices" @click="jobFormIndex = 1;">
          <div class="create-jobs__tab-pane">
            <small style="position: absolute; top: 10px; left: 15px;">Filtering</small>

            <div class="create-jobs__tab-pane--items">
              <div class="create-jobs__tab-pane--item">
                <b-form-select class="tenant-select" v-model="deviceForm.query.scope" :options="bedManagerService.tenants.data" />
              </div>
              <div class="create-jobs__tab-pane--item">
                <b-input v-model="deviceForm.query.deviceId" placeholder="ID" />
              </div>
              <div class="create-jobs__tab-pane--item">
                <b-input v-model="deviceForm.query.firmwareVersion" placeholder="Version" />
              </div>
              <div class="create-jobs__tab-pane--item">
                <button class="create-jobs__filter-devices" :disabled="!treeField || !Array.isArray(treeField.treeData) || !treeField.treeData.length" @click.self.stop="() => {
                  bedManagerService.devices.searchValue = '';
                  treeField.treeData.forEach((fac) => {
                      fac.expanded = false;
                      fac.selected = treeField.filterActive ? fac.selected : false;
                      if (Array.isArray(fac.children)) {
                          fac.children.forEach((unit) => {
                              unit.expanded = false;
                              unit.selected = treeField.filterActive ? unit.selected : false;
                              if (Array.isArray(unit.children)) {
                                  unit.children.forEach((area) => {
                                      area.expanded = false;
                                      area.selected = treeField.filterActive ? area.selected : false;
                                  })
                              }
                          })
                      }
                  });
                  deviceTreeVisible = !deviceTreeVisible;
                }">
                  Location Filtering
                  <div v-if="deviceTreeVisible" v-click-outside="() => {
                        bedManagerService.devices.searchValue = '';
                        treeField.treeData.forEach((fac) => {
                            fac.expanded = false;
                            fac.selected = treeField.filterActive ? fac.selected : false;
                            if (Array.isArray(fac.children)) {
                                fac.children.forEach((unit) => {
                                    unit.expanded = false;
                                    unit.selected = treeField.filterActive ? unit.selected : false;
                                    if (Array.isArray(unit.children)) {
                                        unit.children.forEach((area) => {
                                            area.expanded = false;
                                            area.selected = treeField.filterActive ? area.selected : false;
                                        })
                                    }
                                })
                            }
                        });
                        deviceTreeVisible = false;
                      }"
                      style="
                        font-size: 10px;
                        position: absolute;
                        top: 38px;
                        right: 0px;
                        width: 500px;
                        background: white;
                        z-index: 2;
                        filter: drop-shadow(1px 1px 3px #c7c7c7);
                        border-radius: 5px;
                      ">
                    <themed-location-tree 
                      @areasChange="(event) => {
                        deviceTreeVisible = false;
                        bedManagerService.devices.searchValue = '';
                        this.deviceForm.query.area = event;
                        this.deviceForm.query = {...this.deviceForm.query};
                        const item = this.bedManagerService.devices.headers.find((header) => header.key === 'poc');
                        if (item && event && event.length) {
                          item.filterActive = true;
                        } else if (item) item.filterActive = false;
                        this.bedManagerService.devices.headers = [...this.bedManagerService.devices.headers];
                      }"
                      @searchChange="(event) => {
                        bedManagerService.devices.searchValue = event;
                      }"
                      :activeLocationSearch="bedManagerService.devices.searchValue"
                      :fieldRef="treeField"
                      :treeData="treeField.treeData">
                    </themed-location-tree>
                  </div>
                </button>
              </div>
            </div>

            <b-card class="create-jobs__tab-pane--available-selected">
              <div>
                <small>
                  Available ({{  computedAvailableDeviceList.length }})
                </small>
                <b-button style="position: absolute; top: 0; right: 51%;" @click="toggleDevice(computedAvailableDeviceList)" class="create-jobs__row-button">+</b-button>
                <div class="create-jobs__tab-pane--list">
                  <div class="create-jobs__tab-pane--list-item" v-for="device in computedAvailableDeviceList" :key="device.deviceId + '-AVAILABLE'">
                    <b-button @click="toggleDevice(device)" class="create-jobs__row-button">+</b-button>
                    <small class="create-jobs__tab-pane--list-item-text">
                      <strong>{{ device.deviceId }}</strong>
                      <span v-if="device.location && device.unit && device.area">({{ device.location }} > {{ device.unit }} > {{ device.area }})</span>
                      <span v-else>(UNASSIGNED)</span>
                      <div v-html="device.firmwareVersionFormatted ? device.firmwareVersionFormatted : '0.0.0'"></div> 
                    </small>
                  </div>
                </div>
              </div>
              <div>
                <small>Selected ({{  this.deviceForm.deviceIds.length }})</small>
                <b-button style="position: absolute; top: 0; right: 5px;" @click="removeAllDevices()" class="create-jobs__row-button">-</b-button>
                <div class="create-jobs__tab-pane--list">
                  <div class="create-jobs__tab-pane--list-item" v-for="device in computedSelectedDeviceList" :key="device.deviceId + '-SELECTED'">
                    <small class="create-jobs__tab-pane--list-item-text">
                      {{ device.deviceId }} ({{ device.model }})
                      <span v-if="device.location && device.unit && device.area">({{ device.location }} > {{ device.unit }} > {{ device.area }})</span>
                      <span v-else>(UNASSIGNED)</span>
                    </small>
                    <b-button @click="toggleDevice(device)" class="create-jobs__row-button">-</b-button>
                  </div>
                </div>
              </div>
              <div class="create-jobs__tab-pane--available-selected-divider"></div>
            </b-card>
          </div>
        </b-tab>

        <!-- PREVIEW TAB -->
        <b-tab :title-link-class="'dm__tab-link'" :title="`Preview & Submit`" @click="jobFormIndex = 2;">
          <div class="create-jobs__tab-pane">
            <b-card class="create-jobs__tab-pane--available-selected">
              <div>
                <small>Selected Devices</small>
                <div class="create-jobs__tab-pane--list">
                  <div class="create-jobs__tab-pane--list-item" v-for="device in computedSelectedDeviceList" :key="device.deviceId + '-SELECTED'">
                    <small class="create-jobs__tab-pane--list-item-text">
                      {{ device.deviceId }} ({{ device.model }})
                      <span v-if="device.location && device.unit && device.area">({{ device.location }} > {{ device.unit }} > {{ device.area }})</span>
                      <span v-else>(UNASSIGNED)</span>
                    </small>
                  </div>
                </div>
              </div>
              <div>
                <small>Selected Tasks</small>
                <div class="create-jobs__tab-pane--list">
                  <div class="create-jobs__tab-pane--list-item" v-for="(task, index) in computedSelectedTaskList" :key="task.type + index + '-SELECTED'">
                    <div style="overflow: hidden;" v-for="(key, tIndex) in Object.keys(task.payload)" :key="`task-requirements-${index}-${tIndex}`">
                      <div class="create-jobs__tab-pane--payload-preview">
                        <small><strong style="font-weight: 400;">{{ task.type }}</strong></small>
                        <small class="create-jobs__tab-pane--payload-preview-prop" v-for="(propKey, tpIndex) in Object.keys(task.payload[key])" :key="`task-requirements-${index}-${tIndex}-${tpIndex}`" v-if="propKey.toUpperCase() !== 'ADDITIONAL'">
                          <strong style="font-weight: 400;">{{ propKey.toLocaleUpperCase() }} - </strong><span v-html="task.payload[key][propKey]" />
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="create-jobs__tab-pane--available-selected-divider"></div>
              <b-button :disabled="!tasksForm.valid || !deviceForm.valid" style="width: 70px; height: 30px;" class="create-jobs__row-button" @click="onSubmit()">Submit</b-button>
            </b-card>
          </div>
        </b-tab>
      </b-tabs>
    </b-skeleton-wrapper>
  </div>
</template>
<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import BedManagerService from "../BedManager.service";
import DeviceAPIService from "../../../shared/services/api/Devices.service";
import ThemedLocationTree from "../../../shared/careai/components/ThemedLocationTree.vue";

const moment = require("moment");

Vue.use(VueToast);
Vue.use(Loading);
Vue.component('themed-location-tree', ThemedLocationTree);
export default {
  name: "CreateJobs",
  components: { },
  data() {
    return {
      // Utils
      console: console,
      moment: moment,

      // Contains Domain State and Singleton Pattern Service(s)
      bedManagerService: BedManagerService,
      deviceService: DeviceAPIService,

      // Local State
      deviceTreeVisible: false,
      jobFormIndex: 0,
      selectedDevices: new Map(),
      deviceForm: {
        query: {
          tenant: null,
          location: [],
          unit: [],
          area: [],
          models: [],
          scope: BedManagerService.tenants.selected.value,
        },
        deviceIds: [],
        valid: false,
      },
      tasksForm: {
        tasks: [],
        valid: false,
      },
    };
  },
  computed: {
    treeField() {
      return this.bedManagerService.devices.headers && this.bedManagerService.devices.headers && this.bedManagerService.devices.headers.find((header) => header.key === 'poc') ? 
        this.bedManagerService.devices.headers.find((header) => header.key === 'poc') : []
    },
    currentDMConfiguration() {
      if (this.bedManagerService.configuration) {
          return this.bedManagerService.configuration;
      }
      return null;
    },
    currentDeviceQuery() {
      if (this.deviceForm.query) {
          return this.deviceForm.query;
      }
      return null;
    },
    computedStepper() {
      let stepperState = 1;
      if (this.deviceForm.valid) stepperState += 33;
      if (this.tasksForm.valid) stepperState += 33;
      if (this.jobFormIndex === 2 && this.deviceForm.valid && this.tasksForm.valid) stepperState += 33;
      return `${stepperState}%`;
    },
    computedAvailableDeviceList() {
      return this.bedManagerService.devices.data.filter(
        (device) => !this.deviceForm.deviceIds.includes(device.deviceId)
      );
    },
    computedSelectedDeviceList() {
      return Array.from(this.selectedDevices.values());
    },
    computedAvailableTaskList() {
      return this.bedManagerService.configuration.tasks.map((task) => {
        return {
          ...task,
          payload: {},
          payloadTemplate: task.frontendConfig.payload,
        }
      });
    },
    computedSelectedTaskList() {
      return this.tasksForm.tasks;
    },
    tenant() {
        return this.bedManagerService.tenants.selected;
    }
  },
  watch: {
    tenant() {
      this.deviceForm.query.scope = this.bedManagerService.tenants.selected && this.bedManagerService.tenants.selected.value;
    },
    currentDMConfiguration: {
      deep: true,
      handler() {}
    },
    currentDeviceQuery: {
      deep: true,
      handler() {
        // Models allowed are determined by task configuration / task selection
        const query = { 
          model: 
            this.computedSelectedTaskList.length ? 
              Array.from(this.computedSelectedTaskList.reduce((iterator, val) => {
                if (Array.isArray(val.models)) {
                  val.models.forEach((model) => iterator.add(model));
                }
                return iterator;
              }, new Set()))
            : Array.from(this.currentDMConfiguration.tasks.reduce((iterator, val) => {
              if (Array.isArray(val.models)) {
                val.models.forEach((model) => iterator.add(model));
              }
              return iterator;
            }, new Set()))
        };
        if (this.deviceForm.query['area'] && this.deviceForm.query['area'].length) 
          query.area = this.deviceForm.query['area'];
        if (this.deviceForm.query['deviceId'] && this.deviceForm.query['deviceId'].length) 
          query.deviceId = this.deviceForm.query['deviceId'];
        if (this.deviceForm.query['firmwareVersion'] && this.deviceForm.query['firmwareVersion'].length) 
          query.firmwareVersion = this.deviceForm.query['firmwareVersion'];
        if (this.deviceForm.query.scope) {
          const tenant = this.bedManagerService.tenants.data.find((item) => item.value === this.deviceForm.query.scope);
          this.bedManagerService.tenants.selected = tenant;
          if (this.bedManagerService.tenants.selected && this.bedManagerService.tenants.selected.value !== tenant.value) this.removeAllDevices();
        }
        this.bedManagerService.devices.query = query;
      }
    },
    deviceForm: {
      deep: true,
      handler(value) {
        if (Array.isArray(value.deviceIds) && value.deviceIds.length) {
          value.valid = true;
        } else value.valid = false;
      },
    },
    tasksForm: {
      deep: true,
      handler(form) {
        if (Array.isArray(form.tasks) && form.tasks.length) {
          let valid = true;
          form.tasks.forEach((task) => {
            task.payloadTemplate.forEach((req) => {
              if (!task.payload[req.id]) valid = false; 
            })
          })
          form.valid = valid;
        } else form.valid = false;
      },
    },
  },
  mounted() {
    Vue.directive('click-outside', {
        bind(el, binding, vnode) {
            var vm = vnode.context;
            var callback = binding.value;

            el.clickOutsideEvent = function (event) {
                if (!(el == event.target || el.contains(event.target))) {
                    return callback.call(vm, event);
                }
            };
            document.body.addEventListener('click', el.clickOutsideEvent);
        },
        unbind(el) {
            document.body.removeEventListener('click', el.clickOutsideEvent);
        }
    });
    // Carries over device pane query state for QOL
    Object.keys(this.bedManagerService.devices.query).forEach((key) => {
      if (this.bedManagerService.devices.query[key]) {
        this.deviceForm.query[key] = this.bedManagerService.devices.query[key];
      }
      this.deviceForm.query = { ...this.deviceForm.query };
    });
  },
  unmounted() {},
  methods: {
    onSubmit() {
      const payload = { 
        tenant: this.bedManagerService.tenants.selected.value,
        devices: Array.from(this.selectedDevices.values()).map((device) => {
          const latestCompletedOTAs = device && device.latestCompletedJob && Array.isArray(device.latestCompletedJob.tasks) ? 
            device.latestCompletedJob.tasks.filter(task => task.type === "OTA") : [];
          const latestCompletedJob = latestCompletedOTAs.length && latestCompletedOTAs[latestCompletedOTAs.length - 1].metadata.packageVersion || latestCompletedJob;
          return {
            deviceId: device.deviceId,
            mac: device.serial,
            firmwareVersion: latestCompletedJob || '',
            area: device.areaId,
            unit: device.unitId,
            location: device.locationId
          }
        }), 
        taskList: this.tasksForm.tasks.map((task) => {
          const payload = {
            package: {
              _id: task.payload.package._id,
            }
          }
          return {
            type: task.type,
            payload: payload,
          }
        })
      }

      const willProceed = 
        confirm("Before submitting this job, it is critical that you ensure that you are selecting the correct package to deploy to the selected subset of devices. Press ok to continue, otherwise press cancel.");
      if (willProceed) {
        const action = {
          label: 'Submitting job. Please wait...',
        };
        action.action = 
          Vue.prototype.$DeviceManagerAPIService.postJobs(payload).then(() => {
            setTimeout(() => {
              action.label = 'Job accepted. Job details will be available shortly.';
              setTimeout(() => {
                this.bedManagerService.actions.splice(this.bedManagerService.actions.indexOf(action), 1);
              }, 5000);
            }, 3000)
          });
        this.bedManagerService.actions = action;
      }  

      this.$emit('exit', true);
    },
    onReset() {
      this.form = {
        label: "",
        version: "",
        file: null,
      }
    },
    packageListMutation(arr) {
      const mutated = new Set();
      const firmwareMap = new Map();

      arr.forEach(item => {
        if (item.packageType === 'Firmware') {
          let firmwareList = firmwareMap.get(item.label) || [];
          firmwareList.push(item);
          firmwareMap.set(item.label, firmwareList);
        } else mutated.add(item);
      });
      
      firmwareMap.forEach((value) => {
        const firmware = value.sort((a, b) =>
            a._id.localeCompare(b._id),
          )[value.length - 1];
        mutated.add(firmware);
      })
   
      return Array.from(mutated.values());
    },
    toggleDevice(item) {
      const handler = (devices) => {
        let currentFormDevices = this.deviceForm.deviceIds;
        devices.forEach((device) => {
          if (device.deviceId) {
            if (this.deviceForm.deviceIds.includes(device.deviceId)) {
              this.selectedDevices.delete(device.deviceId);
              currentFormDevices = [ ...currentFormDevices.filter((id) => id !== device.deviceId)];
            } else {
              this.selectedDevices.set(device.deviceId, device);
              currentFormDevices = [ ...currentFormDevices, device.deviceId ];
            }
          }
        });
        this.deviceForm.deviceIds = currentFormDevices;
        this.selectedDevices = new Map(this.selectedDevices);
      }
      if (Array.isArray(item)) {
        const devices = item;
        handler(devices);
      } else {
        const device = item;
        handler([device]);
      }
    },
    removeAllDevices() {
      this.deviceForm.deviceIds = [];
      this.selectedDevices = new Map();
    },
    addTask(task) {
      this.tasksForm.tasks = [ ...this.tasksForm.tasks, JSON.parse(JSON.stringify(task)) ];
    },
    removeTask(index) {
      try {
        this.tasksForm.tasks.splice(index, 1);
        this.tasksForm.tasks = [ ...this.tasksForm.tasks ];
      } catch { null }
    },
  },
};
</script>

<style lang="scss">
  .create-jobs__main {
    .multiselect__single {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 235px;
    }
    .multiselect__tags {
      height: 38px;

      .multiselect__placeholder {
        padding-top: 0px !important;
      }

      input {
        padding-left: 0
      }
    
      input::placeholder {
        font-size: 14px;
        font-weight: 400;
        color: #b6b6b6;
        padding-left: 0px;
      }
    }

    .multiselect__content-wrapper {
      .multiselect__element {
        span {
          font-size: 14px;
          font-weight: 400;
          color: #424242;
        }
      }
    }

    .create-jobs__filter-devices {
      position: relative;
      padding: 7px;
      border-radius: 3px;
      background: #fff;
      transition: all .25s;
      border: 1px solid #ebebeb;
      color: #b1b1b1;
      height: 38px;
      font-weight: 500;

      &:disabled {
        background: #fff !important;
        border-color: #ebebeb !important;
        color: #b1b1b1 !important;
        cursor: not-allowed;
      }

      &:hover {
        color: white;
        border-color: #1dd8f6;
        background: #1dd8f6;
      }
    }

    .card-body > div > small, .create-jobs__tab-pane > small {
      color: #3288D2;
    }

    .card-body > div > small {
      position: absolute;
      top: 8px;
    }

    .nav-tabs {
      border-bottom: 1px solid #e6e6e6 !important;
      padding: 0 15px;
    }

    .nav-tabs .dm__tab-link {
      color: #959595;
      transition: color 500ms;
      border: none;
      font-size: 15px;

      &:hover {
        color: #1dd8f6;
      }

      &.active {
        color: #1dd8f6;
        border-color: #1dd8f6;
        border-bottom: 3px solid #1dd8f6;
      }
    }

    .form-buttons {
      display: flex;
      padding: 5px;
      justify-content: space-between;
      align-items: center;

      .btn-secondary {
        background-color: #f27778;
      }
    }

    .create-jobs__tab-pane {
      display: flex;
      flex-direction: column;
      gap: 5px;
      justify-content: center;
      align-items: flex-start;
      padding: 0;

      .create-jobs__tab-pane--item {
        display: flex;
        flex-direction: column;
        gap: 5px;
        justify-content: center;
        align-items: flex-start;
        padding: 5px;
        flex: 1;
        min-width: 200px;

        .tenant-select {
          option:first-of-type {
            display: none;
          }
        }

        .form-control {
          border-color: #e8e8e8;
          padding: .25rem .5em;
          
          &::placeholder {
            font-size: 12px;
            font-weight: 500;
            color: #b6b6b6;
          }
        }
      }

      .create-jobs__tab-pane--available-selected {
        width: 100%;
        padding: 15px;
        border-radius: 5px;
        border: none;
        position: relative;

        .create-jobs__tab-pane--available-selected-divider {
          position: absolute;
          top: 0;
          bottom: 0;
          border-left: 1px solid #e6e6e6;
          width: 1px; 
          left: 50%;
        }

        > div {
          display: flex;
          flex-direction: row;
          gap: 5px;
          justify-content: flex-end;
          align-items: flex-start;
          padding: 0px;
          flex-wrap: wrap;

          > div {
            width: 49%;
          }
        }
      }

      .create-jobs__tab-pane--list {
        display: flex;
        flex-direction: column;
        gap: 5px;
        max-height: 400px;
        min-height: 400px;
        overflow-y: auto;
        margin-top: 15px;
        overflow-x: hidden;
      }

      .create-jobs__tab-pane--items {
        display: flex;
        justify-content: space-between; 
        width: 100%;
        border-bottom: 1px solid #e6e6e6;
        padding: 10px;
        padding-top: 20px;
        flex-wrap: wrap;
      }
      .create-jobs__tab-pane--list-item {
        display: flex;
        align-items: flex-start;
        gap: 5px;
        padding: 0 5px;

        small {
          flex: 1;
        }
      } 

      .create-jobs__tab-pane--list-item-text {
        display: flex;
        flex-direction: column;

        > span {
          font-size: 12px;
          color: #aaaaaa;
        }
      }

      .create-jobs__row-button {
          height: 25px;
          width: 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0;
          transition: all 500ms;
          background-color: #effefe;
          border: 1px solid rgba(0,181,218,.4);
          color: #c8c8c8;
          font-weight: 200;
          font-size: 12px;

          &:disabled {
            background-color: #ebebeb;
            color: #a5a5a5;
            cursor: not-allowed;
          }

          &:not(:disabled):hover {
              background-color: #1dd8f6;
              color: white;
          }
      }

      .create-jobs__tab-pane--payload-preview {
        display: flex;
        flex-direction: column;

        span, strong, small {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .create-jobs__tab-pane--payload-preview-prop {
          color: #aaa;
          font-size: 12px;
        }
      }
    }

    .create-jobs__helper {
      background: #f2f2f2;
      color: #a9a9a9; 
      font-size: 12px;
    }

    label {
      color: #404040;
    }
    .card {
      border: none;

    }
    .create-jobs__helper {
      .nav-tabs .nav-link.disabled {
        color: #eee;
        cursor: not-allowed;
      }
      border: none;
      border-bottom: 1px solid rgb(210 210 210 / 13%);
    }

    .multiselect__tag {
      background: #1dd8f6;
    }

    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
      background: #18bdd6;
    }

    .multiselect__tag-icon:after {
      color: white;
    }

    .multiselect__option--highlight::after {
      display: none;
    }

    .multiselect__option--selected {
      background-color: #f2fdfe;
    }

    .multiselect__option--selected::after {
      display: none;
    }

    .multiselect__option--highlight {
      background-color: #f2fdfe;
      color: #787878;
    }
  }
</style>  
